import { useNavigate } from "react-router-dom"
import { countQuestions, decks } from "../questions/decks"

export const DeckChooser = () => {
	const navigate = useNavigate()

	return (
		<section style={{ textAlign: "center", maxWidth: "56em", margin: "0 auto", padding: "0.8em 1em 3em" }}>
			<h1 style={{ fontSize: "clamp(1.3em, 4vw, 1.8em)", margin: "0.2em 0", overflowWrap: "break-word" }}>
				Thursday Night Trivia
			</h1>
			<p style={{ fontSize: "0.85em", margin: "0.2em 0", opacity: 0.8 }}>
				Legion Branch 13 · Ben Davidson · arrows move, space reveals
			</p>
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
					gap: "0.45em",
					marginTop: "0.7em",
				}}
			>
				{decks.map(d => (
					<button
						key={d.slug}
						type="button"
						onClick={() => navigate(`/play/${d.slug}/1/1`)}
						style={{
							fontSize: "0.8em",
							padding: "0.45em 0.7em",
							borderRadius: "0.5em",
							backgroundColor: "#dc3545",
							borderColor: "#dc3545",
							color: "white",
							cursor: "pointer",
							textAlign: "left",
						}}
					>
						<b>{d.label}</b>
						<br />
						<span style={{ opacity: 0.9 }}>
							{d.questions.length} {d.questions.length === 1 ? "round" : "rounds"}, {countQuestions(d)} questions
						</span>
					</button>
				))}
			</div>
		</section>
	)
}
